import { SetIsLoadingAction, UpdateSessionInfoAction } from './ActionCreator';
import { SessionInfoActionType } from './ActionTypes';
import SessionInfoState from './Types';

const initialState: SessionInfoState = {
  organization: null,
  accessPermissions: null,
  user: null,
  subscription: null,
  isLoading: false,
};

type SessionInfoActions = UpdateSessionInfoAction | SetIsLoadingAction;

const sessionInfoReducer = (state = initialState, action: SessionInfoActions): SessionInfoState => {
  switch (action.type) {
    case SessionInfoActionType.UpdateSessionInfo: {
      const { sessionInfo } = action.payload;

      return {
        ...state,
        ...sessionInfo,
      };
    }
    case SessionInfoActionType.SetIsLoading:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    default:
      return state;
  }
};

export default sessionInfoReducer;
